import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSalesActivity() {
	return clientSupplier.get("api-supplier/dashboard/status-purchase", {
	});
}

function getSalesResume() {
	return clientSupplier.get("api-supplier/dashboard/total-purchase", {
	});
}

function getReturnActivity() {
	return clientSupplier.get("api-supplier/dashboard/status-return", {
	});
}

function getSalesProduct() {
	return clientSupplier.get("api-supplier/dashboard/purchase", {
	});
}

function getTopWarehouse() {
	return clientSupplier.get("api-supplier/dashboard/top_five", {
	});
}

function getScheduleWaiting() {
	return clientSupplier.get("api-supplier/dashboard/schedule-waiting", {
	});
}

function getScheduleToday() {
	return clientSupplier.get("api-supplier/dashboard/schedule-today", {
	});
}

function getScheduleTomorrow() {
	return clientSupplier.get("api-supplier/dashboard/schedule-tomorrow", {
	});
}

export default {
	getSalesActivity,
	getSalesResume,
	getReturnActivity,
	getSalesProduct,
	getTopWarehouse,
	getScheduleWaiting,
	getScheduleToday,
	getScheduleTomorrow,
}